import { api } from "@/api";
import { QueryConfig, QueryResult } from "@/shared/types/base";
import { Moneda } from "@/shared/types/moneda";
import { sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { sortMonedas } from "../shared/utils";

export async function getMonedas(): Promise<Moneda[]> {
    await sleep(1000);
    const response = await api.get("monetizacion/monedas");
    return sortMonedas(response.data);
}

export function useGetMonedasQuery(queryConfig: QueryConfig<Moneda[]> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getMonedas(),
        queryKey: ["monetizacion", "monedas"],
    })
}

export interface GetMonedasQueryProps {
    queryConfig?: QueryConfig<Moneda[]>,
    children: (queryResult: QueryResult<Moneda[]>) => ReactNode
}

export function GetMonedasQuery({
    children,
    queryConfig
}: GetMonedasQueryProps) {
    const queryResult = useGetMonedasQuery(queryConfig);
    return children && children(queryResult);
}